<div class="card card-class">
  <h5 class="card-title"><mat-icon>settings</mat-icon>App settings</h5>
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#menu1">School</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu2">Supervisor</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu3">Levels</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu4">Subject</a>
    </li>
    <!--<li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu5">Class Set</a>
    </li>-->
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu6">Exam Type</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu7">Question Difficulty</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu9">Difficulty Modifier</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu8">File Upload</a>
    </li>

  </ul>
  <!-- Tab panes -->
  <div class="tab-content">
    <!-- school tab info -->
    <div id="menu1" class="container tab-pane active">
      <br>
      <div class="card-body school-details">
        <h3 class="school-details-header">SCHOOL DETAILS</h3>
        <label class="customize">Customize the app by providing your school details or use the default values</label>
        <form>
          <div class="form-group">
            <label for="classScooldetails">SCHOOL NAME</label>
            <input type="text" formControlName="classSetname" class="form-control" placeholder="Enter school name" />

          </div>
          <div class="form-group">
            <label for="description">MOTTO/MANTRA</label>
            <input type="text" formControlName="description" class="form-control" placeholder="Enter motto" />

          </div>
          <div class="form-group buttons">
            <button class="btn">

              Close
            </button>
            <button class="btn btn-primary next">Next</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Supervisor tab info -->
    <div id="menu2" class="container tab-pane fade">
      <br>
      <div class="card-body school-details">
        <button class="btn add-new-user" (click)="openDialogSupervisor()"><i class="fas fa-plus"></i>ADD NEW SUPERVISOR</button>
        <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
          <div fxFlex="12.5%" *ngFor="let supervisor of supervisorData">
            <mat-card class="mat-elevation-z4">
              <mat-card-content>
                <mat-icon class="center-icon">person</mat-icon>
                <p>
                  {{ supervisor.firstName }}
                </p>
              </mat-card-content>
              <mat-card-actions>
                <mat-icon (click)="editSupervisor(supervisor)">edit</mat-icon>
                <mat-icon (click)="deleteSupervisor(supervisor)">delete</mat-icon>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
        <!-- <form>
            <div class="form-group buttons">
                <button class="btn">
                   Back
                </button>
                <button class="btn btn-primary next">Next</button>
            </div>
        </form> -->
      </div>
    </div>

    <!-- Levels tab info -->
    <div id="menu3" class="container tab-pane fade">
      <br>
      <div class="card-body school-details">
        <button class="btn add-new-user" (click)="openDialogLevel()"><i class="fas fa-plus"></i>ADD NEW LEVEL</button>
        <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
          <div fxFlex="12.5%" *ngFor="let level of levelData">
            <mat-card class="mat-elevation-z4">
              <mat-card-content>
                <mat-icon class="center-icon">school</mat-icon>
                <p>
                  {{level.description}}
                </p>
              </mat-card-content>
              <mat-card-actions>
                <mat-icon (click)="editLevel(level)">edit</mat-icon>
                <mat-icon (click)="deleteLevel(level)">delete</mat-icon>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>

        <!-- <form>

            <div class="form-group buttons">
                <button class="btn">

                    Back
                </button>
                <button class="btn btn-primary next">Next</button>
            </div>
        </form> -->
      </div>
    </div>

    <!-- Subject tab info -->
    <div id="menu4" class="container tab-pane fade">
      <br>
      <div class="card-body school-details">
        <button class="btn add-new-user" (click)="openDialogSubject()"><i class="fas fa-plus"></i>ADD NEW SUBJECT</button>
        <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
          <div fxFlex="12.5%" *ngFor="let subject of subjectData">
            <mat-card class="mat-elevation-z4">
              <mat-card-content>
                <mat-icon class="center-icon">article</mat-icon>
                <p>
                  {{subject.name}}
                </p>
              </mat-card-content>
              <mat-card-actions>
                <mat-icon (click)="editSubject(subject)">edit</mat-icon>
                <mat-icon (click)="deleteSubject(subject)">delete</mat-icon>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
        <!-- <form>

            <div class="form-group buttons">
                <button class="btn">

                    Back
                </button>
                <button class="btn btn-primary next">Next</button>
            </div>
        </form> -->
      </div>
    </div>

    <!-- Class Set tab info -->
    <!--<div id="menu5" class="container tab-pane fade"><br>
    <div class="card-body school-details">
        <button class="btn add-new-user" (click)="openDialogClassSet()"><i class="fas fa-plus"></i>ADD NEW CLASS SET</button>
        <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
          <div fxFlex="12.5%" *ngFor="let classset of classSetData">
            <mat-card class="mat-elevation-z4" >
              <mat-card-content>
                  <mat-icon class="center-icon">groups</mat-icon>
                <p>
                  {{classset.name}}
                </p>
              </mat-card-content>
              <mat-card-actions>
                <mat-icon (click)="editClassSet(classset)">edit</mat-icon>
                <mat-icon (click)="deleteClassSet(classset)">delete</mat-icon>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>-->
    <!-- Exam type tab info -->
    <div id="menu6" class="container tab-pane fade">
      <br>
      <div class="card-body school-details">
        <button class="btn add-new-user" (click)="openDialogExamType()"><i class="fas fa-plus"></i>ADD NEW EXAM TYPE</button>
        <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
          <div fxFlex="12.5%" *ngFor="let examType of examTypeData">
            <mat-card class="mat-elevation-z4">
              <mat-card-content>
                <mat-icon class="center-icon">assignment</mat-icon>
                <p>
                  {{examType.name}}
                </p>
              </mat-card-content>
              <mat-card-actions>
                <mat-icon (click)="editExamType(examType)">edit</mat-icon>
                <mat-icon (click)="deleteExamType(examType)">delete</mat-icon>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
        <!-- <form>

            <div class="form-group buttons">
                <button class="btn">

                    Back
                </button>
                <button class="btn btn-primary next">Next</button>
            </div>
        </form> -->
      </div>
    </div>

    <!--Question difficulty tab info -->
    <div id="menu7" class="container tab-pane fade">
      <br>
      <div class="card-body school-details">
        <button class="btn add-new-user" (click)="openDialogQuestion()"><i class="fas fa-plus"></i>ADD NEW QUESTION DIFFICULTY</button>
        <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
          <div fxFlex="12.5%" *ngFor="let quedif of questionDifData">
            <mat-card class="mat-elevation-z4">
              <mat-card-content>
                <mat-icon class="center-icon">star_half</mat-icon>
                <p>
                  {{quedif.name}}
                </p>
              </mat-card-content>
              <mat-card-actions>
                <mat-icon (click)="editQuestionDifficulty(quedif)">edit</mat-icon>
                <mat-icon (click)="deleteQuestionDifficulty(quedif)">delete</mat-icon>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
      </div>
    </div>

    <!-- File tab info -->
    <div id="menu8" class="container tab-pane fade">
      <br>
      <div class="card-body school-details">
        <button class="btn add-new-user"><i class="fas fa-plus"></i>ADD NEW FILE</button>
        <!--<form>

          <div class="form-group buttons">
            <button class="btn">

              Back
            </button>
            <button class="btn btn-primary next">Next</button>
          </div>
        </form>-->
      </div>
    </div>

    <!--Question difficulty tab info -->
    <div id="menu9" class="container tab-pane fade">
      <br>
      <div class="card-body school-details">
        <button class="btn add-new-user" (click)="openDialogModifier()"><i class="fas fa-plus"></i>ADD DIFFICULTY MODIFIER</button>
        <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
          <div fxFlex="12.5%" *ngFor="let mod of modifierData">
            <mat-card class="mat-elevation-z4">
              <mat-card-content>
                <mat-icon class="center-icon">star_half</mat-icon>
                <p>
                  {{mod.description}}
                </p>
              </mat-card-content>
              <mat-card-actions>
                <mat-icon (click)="editQuestionModifiers(mod)">edit</mat-icon>
                <mat-icon (click)="deleteModifier(mod)">delete</mat-icon>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


